import { AuthService } from 'apps/ubivu-panel/src/app/serveices/auth.service';
import { finalize, takeUntil, tap } from 'rxjs/operators';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigurationsService } from 'apps/ubivu-panel/src/app/serveices/configurations.service';
import { NodeService } from 'apps/ubivu-panel/src/app/serveices/node.service';


@Injectable({
    providedIn: 'root'
  })
export class LightHelper {
    $unsubscribe: Subject<void> = new Subject();
    currentUserDetails: any = {};

    constructor(public authService: AuthService, public _configurationsService: ConfigurationsService,
                public _nodeService: NodeService) {
    }


    getCurrentUserDetails(){
        return this.authService.getCurrentUser();
    }  

    getCustomerTimeZone(params) {

        return this._configurationsService.getCustomerTimeZone(params).pipe(
            takeUntil(this.$unsubscribe),
            finalize(() => {
        }));
    }

    getGISAssetsColumnList(){
        return this._configurationsService.getPoleAssetsMappingList()
        .pipe(takeUntil(this.$unsubscribe), finalize(() => {
        }));
    }

    getThresholdBasedOnConfiguration(type:string){
        let params = {
            "type": type,
            "is_configurable":true,
          }
        return this._nodeService.getActiveAlertListOfConfiguration(params)
          .pipe(takeUntil(this.$unsubscribe), finalize(() => {
          }));
    }

    getEmptyFieldThreshold(type:string){
        let params = {
            "type": type,
            "is_configurable":false,
          }
        return this._nodeService.getListOfSelectedEmptyField(params)
          .pipe(takeUntil(this.$unsubscribe), finalize(() => {
        }));
    }
}

